import React, { useState } from 'react'
import { Form, Input, message, Button } from 'antd'
import Clipboard from 'clipboard'
import axios from 'axios'

const { Search } = Input
const App = () => {
  const formRef = React.useRef(null)
  const inputRef = React.useRef(null)
  const [result, setResult] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [showCodeArea, setShowCodeArea] = useState(false)
  const [messageApi, contextHolder] = message.useMessage()
  React.useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])
  const onSearch = value => {
    // 加个延时，以解决allowClear绕过表单验证直接发请求的问题
    setTimeout(() => {
      // 手动触发表单验证
      formRef.current
        .validateFields()
        .then(() => {
          fetchData(value)
        })
        .catch(errorInfo => {})
    }, 100)
  }
  const fetchData = async str => {
    // 先清空原来的
    setResult('')
    setShowCodeArea(false)
    setIsLoading(true)
    try {
      const result = await axios.post(`video`, {
        url: str
      })
      // 显示代码区域
      setShowCodeArea(true)
      const video = result.data.video
      setResult(video)
    } catch (error) {
      console.log(error)
      if (error.response.status === 500) {
        messageApi.open({
          type: 'error',
          content: '该网址访问不到'
        })
      }
    } finally {
      setIsLoading(false)
    }
  }
  const copyToClipboard = text => {
    const res = Clipboard.copy(text)
    if (res) {
      messageApi.open({
        type: 'success',
        content: '已复制'
      })
    }
  }
  return (
    <>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        autoComplete="off"
        initialValues={{
          str: 'https://m.baidu.com/video/page?pd=video_page&nid=15390084117115984457&sign=&word=%E7%9F%B3%E5%AD%A6%E6%95%8F%E9%99%A2%E5%A3%AB%E9%86%92%E8%84%91%E5%BC%80%E7%AA%8D%E9%92%88%E5%88%BA%E6%B3%95%E5%AE%9E%E6%93%8D%E6%95%99%E5%AD%A64&oword=%E7%9F%B3%E5%AD%A6%E6%95%8F%E9%99%A2%E5%A3%AB%E9%86%92%E8%84%91%E5%BC%80%E7%AA%8D%E9%92%88%E5%88%BA%E6%B3%95%E5%AE%9E%E6%93%8D%E6%95%99%E5%AD%A64&atn=index&ext=%7B%22jsy%22%3A1%7D&top=%7B%22sfhs%22%3A1%2C%22_hold%22%3A2%7D&_t=1697528033562'
        }}
      >
        <Form.Item
          label="视频链接"
          name="str"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入视频链接'
            },
            {
              pattern: new RegExp(
                '^(https?:\\/\\/)?' + // protocol
                  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                  '(\\#[-a-z\\d_]*)?$',
                'i'
              ),
              message: '请输入正确的网址',
              validateFirst: true
            }
          ]}
        >
          <Search
            ref={inputRef}
            onSearch={onSearch}
            enterButton
            loading={isLoading}
            allowClear
          />
        </Form.Item>
      </Form>
      {showCodeArea ? (
        <>
          <Button type="link" href={result}>
            下载视频
          </Button>
          <Button type="primary" onClick={() => copyToClipboard(result)}>
            复制地址
          </Button>
        </>
      ) : (
        ''
      )}
      {contextHolder}
    </>
  )
}
export default App
